export default {
  reports: 'Отчеты',
};
